export default "__VITE_ASSET__oxUeEmJ2__"